const fixDecimalString = (data) => {
  return data && typeof data === 'string'
    ? data.trim().replace(',', '.')
    : null;
};

export { fixDecimalString };
